(function (api) {

	api.KRadnikById = KRadnikById;
	api.GetBrojMjeseci = GetBrojMjeseci;
	api.PodaciORadnikuNaslijedi = PodaciORadnikuNaslijedi;
	api.PonistiKOcjene = PonistiKOcjene;
	api.PonistiCOcjene = PonistiCOcjene;
	api.GetNRMjestoKOcjene = GetNRMjestoKOcjene;
	api.ObrisiKPonasanja = ObrisiKPonasanja;
	
	api.GetKalendarKRadnik = GetKalendarKRadnik;
	api.GetKalendarOdjel = GetKalendarOdjel;
	api.GetKalendarOVrsta = GetKalendarOVrsta;
	api.GetRjesenjaPodredEvents = GetRjesenjaPodredEvents;
	
	api.GetKalendarRadnik = GetKalendarRadnik;
	api.GetKalendarRMjesto = GetKalendarRMjesto;
	api.GetKalendarVRada = GetKalendarVRada;
	api.GetERVEvents = GetERVEvents;
	api.Odobravanje = Odobravanje;
	api.StornirajZahtjevBezStatusa = StornirajZahtjevBezStatusa;
	api.DZahtjevMozeStorno = DZahtjevMozeStorno;
	api.GetRUsavrRadnikaFields = GetRUsavrRadnikaFields;
	api.GetKROstaloRadnikaFields = GetKROstaloRadnikaFields;
	api.GetObiteljRadnikaFields = GetObiteljRadnikaFields;
	api.GetORMjestoRadnikaFields = GetORMjestoRadnikaFields;
	api.GetStaroPRadnikaFields = GetStaroPRadnikaFields;
	api.EduPlanGeneriraj = EduPlanGeneriraj;	
	
	//plan edukacija
	api.GetEduPlanSFields = GetEduPlanSFields;
	api.GetEduPlanSTrFields = GetEduPlanSTrFields;
	api.GetEduKatalogTrFields = GetEduKatalogTrFields;
	api.GetEduPlanSTFields = GetEduPlanSTFields;
	api.EduPlanSObrisi = EduPlanSObrisi;	
	api.EduPlanSTrObrisi = EduPlanSTrObrisi;	
	
	api.GetSlikaRadnika = GetSlikaRadnika;
	
	api.KRadnikGetPromjenePodataka = KRadnikGetPromjenePodataka;
	

	function ObrisiKPonasanja(NRMjestoK) { 
		return $.dsDirectCall({
			method: "ke/ObrisiKPonasanja",
			params: [NRMjestoK]
		});
	};

	function GetNRMjestoKOcjene(NRMjesto) {
		return $.dsDirectCall({
			method: "ke/GetNRMjestoKOcjene",
			params: [NRMjesto]
		});
	};

	function PodaciORadnikuNaslijedi(KRadnik) {
		return $.dsDirectCall({
			method: "ke/PodaciORadnikuNaslijedi",
			params: [KRadnik]
		});
	};

	function KRadnikById(KRadnik) {
		return $.dsDirectCall({
			method: "ke/KRadnikById",
			params: [KRadnik]
		});
	}

	function GetBrojMjeseci(datumOd, datumDo) {
		var datumi = JSON.stringify({ DatumOd: datumOd, DatumDo: datumDo });
		return $.dsDirectCall({
			method: "ke/GetBrojMjeseci",
			params: [{ datum: datumi }]
		});
	}

	function PonistiKOcjene(OcListO) {
		return $.dsDirectCall({
			method: "ke/PonistiKOcjene",
			params: [OcListO]
		});
	};

	function PonistiCOcjene(OcListO) {
		return $.dsDirectCall({
			method: "ke/PonistiCOcjene",
			params: [OcListO]
		});
	};
	
	function GetRjesenjaPodredEvents(params){
		return $.dsDirectCall({
			method: "GetKalendarEvents",
			params: [ params ]
		});
	} 	  

	function GetKalendarKRadnik(params){
		return $.dsDirectCall({
			method: "GetKalendarKRadnik",
			params: [ params ]
		});
	} 
	
	function GetKalendarOdjel(params){
		return $.dsDirectCall({
			method: "GetKalendarOdjel",
			params: [ params ]
		});
	} 
	
	function GetKalendarOVrsta(params){
		return $.dsDirectCall({
			method: "GetKalendarOVrsta",
			params: [ params ]
		});
	} 
	
	
	function GetERVEvents(params){
		return $.dsDirectCall({
			method: "GetERVEvents",
			params: [ params ]
		});
	} 	  

	function GetKalendarRadnik(params){
		return $.dsDirectCall({
			method: "GetKalendarRadnik",
			params: [ params ]
		});
	} 
	
	function GetKalendarRMjesto(params){
		return $.dsDirectCall({
			method: "GetKalendarRMjesto",
			params: [ params ]
		});
	} 
	
	function GetKalendarVRada(params){
		return $.dsDirectCall({
			method: "GetKalendarVRada",
			params: [ params ]
		});
	} 
	
	function Odobravanje(params, callback){
		return $.dsDirectCall({
			method: "Odobravanje",
			params: [ params ]
		})
		.done(callback);
	} 
	
	function StornirajZahtjevBezStatusa(iDZahtjev, callback){
		return $.dsDirectCall({
			method: "StornirajZahtjevBezStatusa",
			params: [ iDZahtjev ]
		})
		.done(callback);
	} 
	function DZahtjevMozeStorno(iDZahtjev, callback){
		return $.dsDirectCall({
			method: "DZahtjevMozeStorno",
			params: [ iDZahtjev ]
		})
		.done(callback);
	} 
	
	function GetRUsavrRadnikaFields(kradnik) {
		return $.dsDirectCall({ 
			method: "GetRUsavrRadnikaFields",
			params: [kradnik]
		});
	}
	function GetKROstaloRadnikaFields(kradnik) {
		return $.dsDirectCall({ 
			method: "GetKROstaloRadnikaFields",
			params: [kradnik]
		});
	}
	function GetObiteljRadnikaFields(kradnik) {
		return $.dsDirectCall({ 
			method: "GetObiteljRadnikaFields",
			params: [kradnik]
		});
	}
	function GetORMjestoRadnikaFields(kradnik) {
		return $.dsDirectCall({ 
			method: "GetORMjestoRadnikaFields",
			params: [kradnik]
		});
	}
	function GetStaroPRadnikaFields(kradnik) {
		return $.dsDirectCall({ 
			method: "GetStaroPRadnikaFields",
			params: [kradnik]
		});
	}
	function GetEduPlanSFields() {
		return $.dsDirectCall({ 
			method: "GetEduPlanSFields"
		});
	}
	function GetEduPlanSTrFields() {
		return $.dsDirectCall({ 
			method: "GetEduPlanSTrFields"
		});
	}
	function GetEduKatalogTrFields() {
		return $.dsDirectCall({ 
			method: "GetEduKatalogTrFields"
		});
	}
	function EduPlanGeneriraj(eduplan) {
		return $.dsDirectCall({ 
			method: "EduPlanGeneriraj",
			params: [eduplan]
		});
	}
	function GetEduPlanSTFields() {
		return $.dsDirectCall({ 
			method: "GetEduPlanSTFields"
		});
	}
	
	function EduPlanSObrisi(eduPlanS){
		return $.dsDirectCall({
			method: "EduPlanSObrisi",
			params: [ eduPlanS ]
		});
	}
	
	function EduPlanSTrObrisi(eduPlanSTr){
		return $.dsDirectCall({
			method: "EduPlanSTrObrisi",
			params: [ eduPlanSTr ]
		});
	}
	
	function GetSlikaRadnika(kradnik){
		return $.dsDirectCall({
            method: "GetSlikaRadnika",
            params: [ kradnik ]
        });
	}
	
	function KRadnikGetPromjenePodataka(iKRadnik, iGrupaPodataka, iRedni) { 
		return $.dsDirectCall({
			method: "ke/KRadnikGetPromjenePodataka",
			params: [iKRadnik, iGrupaPodataka, iRedni]
		});
	};

} (konto.ke.api = {}));